import { render, staticRenderFns } from "./MAvatar.vue?vue&type=template&id=f5479776&scoped=true&"
import script from "./MAvatar.vue?vue&type=script&lang=js&"
export * from "./MAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5479776",
  null
  
)

export default component.exports